var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEth = function SvgEth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#71757A",
    fillRule: "evenodd",
    d: "M4 .5v8.479L.123 7.074zm0 0v8.478l3.877-1.904zm0 9.265V13.5L.123 7.627zM4 13.5V9.765l3.877-2.138z",
    clipRule: "evenodd"
  })));
};
export default SvgEth;